import { useMutation } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type {
  SingleCompanyOverviewMarketApproachResponse,
  CompanyOverviewMarketApproachAttribute,
} from 'types/CompanyOverview'

type MutationVariables = Pick<
  CompanyOverviewMarketApproachAttribute,
  'marketApproachID' | 'companyOverviewID'
>
export const useAddCompanyOverviewMarketApproaches = () => {
  const addCompanyOverviewMarketApproach = (
    mutationVariables: MutationVariables
  ) => {
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_MARKET_APPROACHES,
        attributes: mutationVariables,
      },
    }

    const url = generateURL(
      SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_MARKET_APPROACHES
    )
    return fetchWrapper<SingleCompanyOverviewMarketApproachResponse>({
      url,
      method: 'POST',
      body,
    })
  }

  return useMutation(
    'addCompanyOverviewMarketApproaches',
    addCompanyOverviewMarketApproach,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to add market approach: ${error.message}`)
        }
      },
    }
  )
}
